import { group } from 'console';

import { CssVariableType, CssVariable, VariableGroup } from '../types';
import { getInfoObject } from 'utils/tokenService';

const buttonVariablesMetaData: CssVariable[] = [
  // Button Primary
  {
    group: VariableGroup.Button,
    key: '--ts-var-button--primary-background',
    type: CssVariableType.Color,
    name: 'Background Color',
    subGroup: 'Primary',
  },
  {
    group: VariableGroup.Button,
    key: '--ts-var-button--primary--hover-background',
    type: CssVariableType.Color,
    name: 'Hover Background Color',
    subGroup: 'Primary',
  },
  {
    group: VariableGroup.Button,
    key: '--ts-var-button--primary--active-background',
    type: CssVariableType.Color,
    name: 'Active Background Color',
    subGroup: 'Primary',
  },
  {
    group: VariableGroup.Button,
    key: '--ts-var-button--primary-color',
    type: CssVariableType.Color,
    name: 'Text Color',
    subGroup: 'Primary',
  },

  {
    group: VariableGroup.Button,
    key: '--ts-var-button--primary--font-family',
    type: CssVariableType.Font,
    name: 'Font Family',
    subGroup: 'Primary',
  },

  // Button Secondary

  {
    group: VariableGroup.Button,
    key: '--ts-var-button--secondary-background',
    type: CssVariableType.Color,
    name: 'Background Color',
    subGroup: 'Secondary',
  },
  {
    group: VariableGroup.Button,
    key: '--ts-var-button--secondary--hover-background',
    type: CssVariableType.Color,
    name: 'Hover Background Color',
    subGroup: 'Secondary',
  },
  {
    group: VariableGroup.Button,
    key: '--ts-var-button--secondary--active-background',
    type: CssVariableType.Color,
    name: 'Active Background',
    subGroup: 'Secondary',
  },
  {
    group: VariableGroup.Button,
    key: '--ts-var-button--secondary-color',
    type: CssVariableType.Color,
    name: 'Text Color',
    subGroup: 'Secondary',
  },
  {
    group: VariableGroup.Button,
    key: '--ts-var-button--secondary--font-family',
    type: CssVariableType.Font,
    name: 'Font Family',
    subGroup: 'Secondary',
  },

  // Button Tertiary
  {
    group: VariableGroup.Button,
    key: '--ts-var-button--tertiary-background',
    type: CssVariableType.Color,
    name: 'Background Color',
    subGroup: 'Tertiary',
  },
  {
    group: VariableGroup.Button,
    key: '--ts-var-button--tertiary--hover-background',
    type: CssVariableType.Color,
    name: 'Hover Background Color',
    subGroup: 'Tertiary',
  },
  {
    group: VariableGroup.Button,
    key: '--ts-var-button--tertiary--active-background',
    type: CssVariableType.Color,
    name: 'Active Background',
    subGroup: 'Tertiary',
  },
  {
    group: VariableGroup.Button,
    key: '--ts-var-button--tertiary-color',
    type: CssVariableType.Color,
    name: 'Text Color',
    subGroup: 'Tertiary',
  },

  // other
  {
    group: VariableGroup.Button,
    key: '--ts-var-button-border-radius',
    type: CssVariableType.Size,
    name: 'Border Radius',
    subGroup: 'Other',
  },
  {
    group: VariableGroup.Button,
    key: '--ts-var-button--icon-border-radius',
    type: CssVariableType.Size,
    name: 'Icon Border Radius',
    subGroup: 'Other',
  },
];

const spotterVariablesMetaData: any[] = [
  {
    group: VariableGroup.Spotter,
    key: '--ts-var-spotter-input-background',
    type: CssVariableType.Color,
    name: 'Input Background',
  },
  {
    group: VariableGroup.Spotter,
    key: '--ts-var-spotter-prompt-background',
    type: CssVariableType.Color,
    name: 'Prompt Background',
  },
];

const applicationVariablesMetaData: any[] = [
  {
    group: VariableGroup.Application,
    key: '--ts-var-root-background',
    subGroup: 'Root',
    type: CssVariableType.Color,
    name: 'Background Color',
  },
  {
    group: VariableGroup.Application,
    key: '--ts-var-segment-control-hover-background',
    type: CssVariableType.Color,
    name: 'Hover Background',
    subGroup: 'Segment Control',
  },
  {
    group: VariableGroup.Application,
    key: '--ts-var-root-secondary-color',
    type: CssVariableType.Color,
    name: 'Secondary Color',
  },
  {
    group: VariableGroup.Application,
    key: '--ts-var-application-color',
    type: CssVariableType.Color,
    name: 'Text Color',
  },
  {
    group: VariableGroup.Application,
    key: '--ts-var-root-color',
    subGroup: 'Root',
    type: CssVariableType.Color,
    name: 'Text Color',
    defaultValue: '#000',
  },
  {
    group: VariableGroup.Application,
    key: '--ts-var-root-font-family',
    subGroup: 'Root',
    type: CssVariableType.Font,
    name: 'Font Family',
  },
  {
    group: VariableGroup.Application,
    key: '--ts-var-root-text-transform',
    subGroup: 'Root',
    type: CssVariableType.TextTransform,
    name: 'Text Transform',
  },
];

const searchVariablesMetaData: any[] = [
  {
    group: VariableGroup.Search,
    key: '--ts-var-search-bar-background',
    type: CssVariableType.Color,
    name: 'Background',
    subGroup: 'Search Bar',
  },
  {
    group: VariableGroup.Search,
    key: '--ts-var-search-bar-text-font-color',
    type: CssVariableType.Color,
    name: 'Text Color',
    subGroup: 'Search Bar',
  },
  {
    group: VariableGroup.Search,
    key: '--ts-var-search-bar-text-font-family',
    type: CssVariableType.Font,
    name: 'Font Family',
    subGroup: 'Search Bar',
  },
  {
    group: VariableGroup.Search,
    key: '--ts-var-search-bar-text-font-style',
    type: CssVariableType.TextTransform,
    name: 'Text Transform',
    subGroup: 'Search Bar',
  },

  // Auto Complete
  {
    group: VariableGroup.Search,
    key: '--ts-var-search-auto-complete-background',
    type: CssVariableType.Color,
    name: 'Background Color',
    subGroup: 'Auto Complete',
  },
  {
    group: VariableGroup.Search,
    key: '--ts-var-search-bar-auto-complete-hover-background',
    type: CssVariableType.Color,
    name: 'Hover Background',
    subGroup: 'Auto Complete',
  },
  {
    group: VariableGroup.Search,
    key: '--ts-var-search-auto-complete-font-color',
    type: CssVariableType.Color,
    name: 'Text Color',
    subGroup: 'Auto Complete',
  },
  {
    group: VariableGroup.Search,
    key: '--ts-var-search-auto-complete-subtext-font-color',
    type: CssVariableType.Color,
    name: 'Subtext Font Color',
    subGroup: 'Auto Complete',
  },

  {
    group: VariableGroup.Search,
    key: '--ts-var-answer-edit-panel-background-color',
    type: CssVariableType.Color,
    name: 'Background Color',
    subGroup: 'Edit Panel',
  },
  {
    group: VariableGroup.Search,
    key: '--ts-var-search-navigation-button-background',
    type: CssVariableType.Color,
    name: 'Navigation Button Background',
    subGroup: 'Edit Panel',
  },
  {
    group: VariableGroup.Search,
    key: '--ts-var-search-bar-navigation-help-text-background',
    type: CssVariableType.Color,
    name: 'Navigation Help Background',
    subGroup: 'Edit Panel',
  },
  {
    group: VariableGroup.Search,
    key: '--ts-var-answer-data-panel-background-color',
    type: CssVariableType.Color,
    name: 'Background Color',
    subGroup: 'Data Panel',
  },
  {
    group: VariableGroup.Search,
    key: '--ts-var-answer-view-table-chart-switcher-background',
    type: CssVariableType.Color,
    name: 'Background Color',
    subGroup: 'Chart Switcher',
  },
  {
    group: VariableGroup.Search,
    key: '--ts-var-answer-view-table-chart-switcher-active-background',
    type: CssVariableType.Color,
    name: 'Active Background Color',
    subGroup: 'Chart Switcher',
  },
  {
    group: VariableGroup.Search,
    key: '--ts-var-answer-chart-select-background',
    type: CssVariableType.Color,
    name: 'Selected Chart Background',
    subGroup: 'Chart Selection Widget',
  },
  {
    group: VariableGroup.Search,
    key: '--ts-var-answer-chart-hover-background',
    type: CssVariableType.Color,
    name: 'Selected Chart Hover Background',
    subGroup: 'Chart Selection Widget',
  },
];

const objectListVariablesMetaData: any[] = [
  {
    group: VariableGroup.List,
    key: '--ts-var-list-selected-background',
    type: CssVariableType.Color,
    name: 'Selected Background Color',
  },
  {
    group: VariableGroup.List,
    key: '--ts-var-list-hover-background',
    type: CssVariableType.Color,
    name: 'Hover Background Color',
  },
];

const modularHomepageVariablesMetaData: any[] = [
  {
    group: VariableGroup.ModularHomepage,
    key: '--ts-var-home-card-color',
    type: CssVariableType.Color,
    name: 'Home Background Color',
    subGroup: 'Home Page',
  },
  {
    group: VariableGroup.ModularHomepage,
    key: '--ts-var-home-favorite-suggestion-card-background',
    subGroup: 'Favorite Cards',
    type: CssVariableType.Color,
    name: 'Background Color',
  },
  {
    group: VariableGroup.ModularHomepage,
    key: '--ts-var-home-favorite-suggestion-card-text-color',
    subGroup: 'Favorite Cards',
    type: CssVariableType.Color,
    name: 'Text Color',
  },
  {
    group: VariableGroup.ModularHomepage,
    key: '--ts-var-home-favorite-suggestion-card-text-font-color',
    type: CssVariableType.Color,
    name: 'Text Font Color',
    subGroup: 'Favorite Cards',
  },
  {
    group: VariableGroup.ModularHomepage,
    key: '--ts-var-home-favorite-suggestion-card-icon-color',
    subGroup: 'Favorite Cards',
    type: CssVariableType.Color,
    name: 'Icon Color',
  },
  {
    group: VariableGroup.ModularHomepage,
    key: '--ts-var-home-watchlist-selected-text-color',
    subGroup: 'KPI Watchlist',
    type: CssVariableType.Color,
    name: 'Selected Text Color',
  },
];

const checkboxVariablesMetaData: any[] = [
  {
    group: VariableGroup.Checkbox,
    key: '--ts-var-checkbox-background-color',
    type: CssVariableType.Color,
    name: 'Background Color',
  },
  {
    group: VariableGroup.Checkbox,
    key: '--ts-var-checkbox-active-color',
    type: CssVariableType.Color,
    name: 'Active Color',
  },
  {
    group: VariableGroup.Checkbox,
    key: '--ts-var-checkbox-checked-color',
    type: CssVariableType.Color,
    name: 'Checked Color',
  },

  {
    group: VariableGroup.Checkbox,
    key: '--ts-var-checkbox-border-color',
    type: CssVariableType.Color,
    name: 'Border Color',
  },
  {
    group: VariableGroup.Checkbox,
    key: '--ts-var-checkbox-hover-border',
    type: CssVariableType.Color,
    name: 'Hover Border Color',
  },
  {
    group: VariableGroup.Checkbox,
    key: '--ts-var-checkbox-error-border',
    type: CssVariableType.Color,
    name: 'Error Border Color',
  },
  {
    group: VariableGroup.Checkbox,
    key: '--ts-var-checkbox-checked-disabled',
    type: CssVariableType.Color,
    name: 'Checked Disabled Color',
  },
  {
    group: VariableGroup.Checkbox,
    key: '--ts-var-checkbox-highlighted-hover-color',
    type: CssVariableType.Color,
    name: 'Highlighted Hover Color',
    subGroup: 'Highlighted',
  },
];

const menuVariablesMetaData: any[] = [
  {
    group: VariableGroup.Menu,
    key: '--ts-var-menu-background',
    type: CssVariableType.Color,
    name: 'Background Color',
  },
  {
    group: VariableGroup.Menu,
    key: '--ts-var-menu--hover-background',
    type: CssVariableType.Color,
    name: 'Hover Background Color',
  },
  {
    group: VariableGroup.Menu,
    key: '--ts-var-menu-color',
    type: CssVariableType.Color,
    name: 'Text Color',
  },
  {
    group: VariableGroup.Menu,
    key: '--ts-var-menu-selected-text-color',
    type: CssVariableType.Color,
    name: 'Selected Text Color',
  },
  {
    group: VariableGroup.Menu,
    key: '--ts-var-menu-font-family',
    type: CssVariableType.Font,
    name: 'Font Family',
  },
  {
    group: VariableGroup.Menu,
    key: '--ts-var-menu-text-transform',
    type: CssVariableType.TextTransform,
    name: 'Text Transform',
  },
  {
    group: VariableGroup.Menu,
    key: '--ts-var-menu-seperator-background',
    type: CssVariableType.Color,
    name: 'Background Color',
    subGroup: 'Separator',
  },
];

const chartsVariablesMetaData: any[] = [
  {
    group: VariableGroup.Charts,
    key: '--ts-var-viz-background',
    type: CssVariableType.Color,
    name: 'Background Color',
  },
  {
    group: VariableGroup.Charts,
    key: '--ts-var-viz-border-radius',
    type: CssVariableType.Size,
    name: 'Border Radius',
  },
  {
    group: VariableGroup.Charts,
    key: '--ts-var-viz-description-color',
    type: CssVariableType.Color,
    name: 'Text Color',
    subGroup: 'Description',
  },
  {
    group: VariableGroup.Charts,
    key: '--ts-var-viz-description-font-family',
    type: CssVariableType.Font,
    name: 'Font Family',
    subGroup: 'Description',
  },
  {
    group: VariableGroup.Charts,
    key: '--ts-var-viz-description-text-transform',
    type: CssVariableType.TextTransform,
    name: 'Text Transform',
    subGroup: 'Description',
  },
  {
    group: VariableGroup.Charts,
    key: '--ts-var-viz-box-shadow',
    type: CssVariableType.BoxShadow,
    name: 'Box Shadow',
  },

  {
    group: VariableGroup.Charts,
    key: '--ts-var-viz-title-color',
    type: CssVariableType.Color,
    name: 'Title Color',
    subGroup: 'Title',
  },
  {
    group: VariableGroup.Charts,
    key: '--ts-var-viz-title-font-family',
    type: CssVariableType.Font,
    name: 'Title Font Family',
    subGroup: 'Title',
  },
  {
    group: VariableGroup.Charts,
    key: '--ts-var-viz-title-text-transform',
    type: CssVariableType.TextTransform,
    name: 'Title Text Transform',
    subGroup: 'Title',
  },

  {
    group: VariableGroup.Charts,
    key: '--ts-var-axis-title-color',
    type: CssVariableType.Color,
    name: 'Axis Title Color',
    subGroup: 'Axis Title',
  },
  {
    group: VariableGroup.Charts,
    key: '--ts-var-axis-title-font-family',
    type: CssVariableType.Font,
    name: 'Axis Title Font Family',
    subGroup: 'Axis Title',
  },
  {
    group: VariableGroup.Charts,
    key: '--ts-var-axis-data-label-color',
    type: CssVariableType.Color,
    name: 'Text Color',
    subGroup: 'Axis Data',
  },
  {
    group: VariableGroup.Charts,
    key: '--ts-var-axis-data-label-font-family',
    type: CssVariableType.Font,
    name: 'Font Family',
    subGroup: 'Axis Data',
  },
  {
    group: VariableGroup.Charts,
    key: '--ts-var-viz-legend-hover-background',
    type: CssVariableType.Color,
    name: 'Hover Background Color',
    subGroup: 'Legend',
  },
  {
    group: VariableGroup.Charts,
    key: '--ts-var-kpi-hero-color',
    type: CssVariableType.Color,
    name: 'KPI Hero Color',
    subGroup: 'KPI',
  },
  {
    group: VariableGroup.Charts,
    key: '--ts-var-kpi-comparison-color',
    type: CssVariableType.Color,
    name: 'KPI Comparison Color',
    subGroup: 'KPI',
  },
  {
    group: VariableGroup.Charts,
    key: '--ts-var-kpi-positive-change-color',
    type: CssVariableType.Color,
    name: 'KPI Positive Change Color',
    subGroup: 'KPI',
  },
  {
    group: VariableGroup.Charts,
    key: '--ts-var-kpi-negative-change-color',
    type: CssVariableType.Color,
    name: 'KPI Negative Change Color',
    subGroup: 'KPI',
  },
  {
    group: VariableGroup.Charts,
    key: '--ts-var-kpi-analyze-text-color',
    type: CssVariableType.Color,
    name: 'KPI Analyze Text Color',
    subGroup: 'KPI',
  },

  {
    group: VariableGroup.Charts,
    key: '--ts-var-chart-heatmap-legend-title-color',
    type: CssVariableType.Color,
    name: 'Legend Title Color',
    subGroup: 'Chart Heatmap Legend',
  },
  {
    group: VariableGroup.Charts,
    key: '--ts-var-chart-treemap-legend-label-color',
    type: CssVariableType.Color,
    name: 'Legend Label Color',
    subGroup: 'Chart Treemap Legend',
  },
  {
    group: VariableGroup.Charts,
    key: '--ts-var-chart-treemap-legend-title-color',
    type: CssVariableType.Color,
    name: 'Legend Title Color',
    subGroup: 'Chart Treemap Legend',
  },
  {
    group: VariableGroup.Charts,
    key: '--ts-var-chart-heatmap-legend-label-color',
    type: CssVariableType.Color,
    name: 'Legend Label Color',
    subGroup: 'Chart Treemap Legend',
  },
];

const navbarVariablesMetaData: any[] = [
  {
    group: VariableGroup.Navbar,
    key: '--ts-var-nav-background',
    type: CssVariableType.Color,
    name: 'Background Color',
  },
  {
    group: VariableGroup.Navbar,
    key: '--ts-var-nav-color',
    type: CssVariableType.Color,
    name: 'Text Color',
  },
  {
    group: VariableGroup.Navbar,
    key: '--ts-var-search-data-button-background',
    type: CssVariableType.Color,
    name: 'Button Background',
    subGroup: 'Search Data',
  },
  {
    group: VariableGroup.Navbar,
    key: '--ts-var-search-data-button-font-color',
    type: CssVariableType.Color,
    name: 'Button Font Color',
    subGroup: 'Search Data',
  },
  {
    group: VariableGroup.Navbar,
    key: '--ts-var-search-data-button-font-family',
    type: CssVariableType.Font,
    name: 'Button Font Family',
    subGroup: 'Search Data',
  },
];

const nlsVariablesMetaData: any[] = [
  {
    group: VariableGroup.NLS,
    key: '--ts-var-sage-bar-header-background-color',
    type: CssVariableType.Color,
    name: 'Header Background Color',
    subGroup: 'Sage Bar',
  },
  {
    group: VariableGroup.NLS,
    key: '--ts-var-sage-bar-header-text-color',
    type: CssVariableType.Color,
    name: 'Header Text Color',
    subGroup: 'Sage Bar',
  },
  {
    group: VariableGroup.NLS,
    key: '--ts-var-source-selector-background-color',
    type: CssVariableType.Color,
    name: 'Data Source Selector Background Color',
    subGroup: 'Data Source Selector',
  },
  {
    group: VariableGroup.NLS,
    key: '--ts-var-source-selector-hover-color',
    type: CssVariableType.Color,
    name: 'Hover Color',
    subGroup: 'Data Source Selector',
  },

  {
    group: VariableGroup.NLS,
    key: '--ts-var-sage-search-box-background-color',
    type: CssVariableType.Color,
    name: 'Search Box Background Color',
    subGroup: 'Search Box',
  },
  {
    group: VariableGroup.NLS,
    key: '--ts-var-sage-search-box-font-color',
    type: CssVariableType.Color,
    name: 'Search Box Font Color',
    subGroup: 'Search Box',
  },

  {
    group: VariableGroup.NLS,
    key: '--ts-var-sage-embed-background-color',
    type: CssVariableType.Color,
    name: 'Embed Background Color',
    subGroup: 'Sage Embed',
  },
  {
    group: VariableGroup.NLS,
    key: '--ts-var-sage-seed-questions-background',
    type: CssVariableType.Color,
    name: 'Background Color',
    subGroup: 'Seed Questions',
  },
  {
    group: VariableGroup.NLS,
    key: '--ts-var-sage-seed-questions-hover-background',
    type: CssVariableType.Color,
    name: 'Hover Background',
    subGroup: 'Seed Questions',
  },
  {
    group: VariableGroup.NLS,
    key: '--ts-var-sage-seed-questions-font-color',
    type: CssVariableType.Color,
    name: 'Font Color',
    subGroup: 'Seed Questions',
  },
];

const chipVariablesMetaData: any[] = [
  {
    group: VariableGroup.Chip,
    key: '--ts-var-chip-border-radius',
    type: CssVariableType.Size,
    name: 'Border Radius',
  },

  {
    group: VariableGroup.Chip,
    key: '--ts-var-chip-title-font-family',
    type: CssVariableType.Font,
    name: 'Title Font Family',
  },

  {
    group: VariableGroup.Chip,
    key: '--ts-var-chip-background',
    type: CssVariableType.Color,
    name: 'Background Color',
    subGroup: 'Filter Chips',
  },
  {
    group: VariableGroup.Chip,
    key: '--ts-var-chip--hover-background',
    type: CssVariableType.Color,
    name: 'Hover Background Color',
    subGroup: 'Filter Chips',
  },
  {
    group: VariableGroup.Chip,
    key: '--ts-var-chip--active-background',
    type: CssVariableType.Color,
    name: 'Active Background Color',
    subGroup: 'Filter Chips',
  },
  {
    group: VariableGroup.Chip,
    key: '--ts-var-chip-color',
    type: CssVariableType.Color,
    name: 'Text Color',
    subGroup: 'Filter Chips',
  },
  {
    group: VariableGroup.Chip,
    key: '--ts-var-chip--hover-color',
    type: CssVariableType.Color,
    name: 'Hover Text Color',
    subGroup: 'Filter Chips',
  },
  {
    group: VariableGroup.Chip,
    key: '--ts-var-chip--active-color',
    type: CssVariableType.Color,
    name: 'Active Text Color',
    subGroup: 'Filter Chips',
  },

  {
    group: VariableGroup.Chip,
    key: '--ts-var-parameter-chip-background',
    type: CssVariableType.Color,
    name: 'Background Color',
    subGroup: 'Parameter Chip',
  },
  {
    group: VariableGroup.Chip,
    key: '--ts-var-parameter-chip-hover-background',
    type: CssVariableType.Color,
    name: 'Hover Background Color',
    subGroup: 'Parameter Chip',
  },
  {
    group: VariableGroup.Chip,
    key: '--ts-var-parameter-chip-active-background',
    type: CssVariableType.Color,
    name: 'Active Background Color',
    subGroup: 'Parameter Chip',
  },
  {
    group: VariableGroup.Chip,
    key: '--ts-var-parameter-chip-text-color',
    type: CssVariableType.Color,
    name: 'Text Color',
    subGroup: 'Parameter Chip',
  },
  {
    group: VariableGroup.Chip,
    key: '--ts-var-parameter-chip-hover-text-color',
    type: CssVariableType.Color,
    name: 'Hover Font Color',
    subGroup: 'Parameter Chip',
  },
  {
    group: VariableGroup.Chip,
    key: '--ts-var-parameter-chip-active-text-color',
    type: CssVariableType.Color,
    name: 'Active Text Color',
    subGroup: 'Parameter Chip',
  },
  {
    group: VariableGroup.Chip,
    key: '--ts-var-chip-box-shadow',
    type: CssVariableType.BoxShadow,
    name: 'Box Shadow',
    subGroup: 'Box Shadow',
  },
];

const dialogVariablesMetaData: any[] = [
  {
    group: VariableGroup.Dialog,
    key: '--ts-var-dialog-header-background',
    type: CssVariableType.Color,
    name: 'Background Color',
    subGroup: 'Header',
  },
  {
    group: VariableGroup.Dialog,
    key: '--ts-var-dialog-header-color',
    type: CssVariableType.Color,
    name: 'Font Color',
    subGroup: 'Header',
  },
  {
    group: VariableGroup.Dialog,
    key: '--ts-var-dialog-body-background',
    type: CssVariableType.Color,
    name: 'Background Color',
    subGroup: 'Body',
  },
  {
    group: VariableGroup.Dialog,
    key: '--ts-var-dialog-body-color',
    type: CssVariableType.Color,
    name: 'Text Color',
    subGroup: 'Body',
  },
  {
    group: VariableGroup.Dialog,
    key: '--ts-var-dialog-footer-background',
    type: CssVariableType.Color,
    name: 'Background Color',
    subGroup: 'Footer',
  },
];

const getLiveboardVariablesMetaData = async (): Promise<any[]> => {
  const infoObject = (await getInfoObject()) as any;
  const liveboardGroupingEnabled = infoObject?.info?.configInfo?.isLiveboardStylingEnabled;
  return [
    // Header
    {
      group: VariableGroup.Liveboard,
      key: '--ts-var-liveboard-header-background',
      type: CssVariableType.Color,
      name: 'Header Background Color',
      subGroup: 'Header',
    },
    {
      group: VariableGroup.Liveboard,
      key: '--ts-var-liveboard-header-font-color',
      type: CssVariableType.Color,
      name: 'Header Font Color',
      subGroup: 'Header',
    },
    {
      group: VariableGroup.Liveboard,
      key: '--ts-var-liveboard-header-fontsize',
      type: CssVariableType.Size,
      name: 'Header Font Size',
      subGroup: 'Header',
    },

    // Tile
    {
      group: VariableGroup.Liveboard,
      key: '--ts-var-liveboard-tile-background',
      type: CssVariableType.Color,
      name: 'Background Color',
      subGroup: 'Tile',
    },
    {
      group: VariableGroup.Liveboard,
      key: '--ts-var-viz-tile-height',
      type: CssVariableType.Size,
      name: 'Tile Height',
      subGroup: 'Tile',
    },
    {
      group: VariableGroup.Liveboard,
      key: '--ts-var-liveboard-tile-border-color',
      type: CssVariableType.Color,
      name: 'Tile Border Color',
      subGroup: 'Tile',
    },
    {
      group: VariableGroup.Liveboard,
      key: '--ts-var-liveboard-tile-border-radius',
      type: CssVariableType.Size,
      name: 'Tile Border Radius',
      subGroup: 'Tile',
    },
    {
      group: VariableGroup.Liveboard,
      key: '--ts-var-liveboard-tile-padding',
      type: CssVariableType.Size,
      name: 'Tile Padding',
      subGroup: 'Tile',
    },
    {
      group: VariableGroup.Liveboard,
      key: '--ts-var-liveboard-tile-table-header-background',
      type: CssVariableType.Color,
      name: 'Table Header Background Color',
      subGroup: 'Tile Header',
    },

    {
      group: VariableGroup.Liveboard,
      key: '--ts-var-liveboard-tile-title-fontsize',
      type: CssVariableType.Size,
      name: 'Title Font Size',
      subGroup: 'Tile Title',
    },
    {
      group: VariableGroup.Liveboard,
      key: '--ts-var-liveboard-tile-title-fontweight',
      type: CssVariableType.Size,
      name: 'Title Font Weight',
      subGroup: 'Tile Title',
    },
    {
      group: VariableGroup.Liveboard,
      key: '--ts-var-liveboard-tile-description-font-weight',
      type: CssVariableType.Size,
      name: 'Description Font Weight',
      subGroup: 'Tile Description',
    },
    {
      group: VariableGroup.Liveboard,
      key: '--ts-var-liveboard-tile-description-opacity',
      type: CssVariableType.Size,
      name: 'Description Opacity',
      subGroup: 'Tile Description',
    },

    {
      group: VariableGroup.Liveboard,
      key: '--ts-var-liveboard-layout-background',
      type: CssVariableType.Color,
      name: 'Background Color',
      subGroup: 'Layout',
    },
    {
      group: VariableGroup.Liveboard,
      key: '--ts-var-liveboard-layout-title-color',
      type: CssVariableType.Color,
      name: 'Title Color',
      subGroup: 'Layout',
    },
    {
      group: VariableGroup.Liveboard,
      key: '--ts-var-liveboard-layout-title-fontsize',
      type: CssVariableType.Size,
      name: 'Title Font Size',
      subGroup: 'Layout',
    },
    // Group

    ...((liveboardGroupingEnabled && [
      {
        group: VariableGroup.Liveboard,
        key: '--ts-var-liveboard-group-padding',
        type: CssVariableType.Size,
        name: 'Padding',
        subGroup: 'Group',
      },
      {
        group: VariableGroup.Liveboard,
        key: '--ts-var-liveboard-group-title-padding',
        type: CssVariableType.Size,
        name: 'Title Padding',
        subGroup: 'Group',
      },
      {
        group: VariableGroup.Liveboard,
        key: '--ts-var-liveboard-group-title-font-size',
        type: CssVariableType.Size,
        name: 'Title Font Size',
        subGroup: 'Group',
      },
      {
        group: VariableGroup.Liveboard,
        key: '--ts-var-liveboard-group-title-font-weight',
        type: CssVariableType.Size,
        name: 'Title Font Weight',
        subGroup: 'Group',
      },

      {
        group: VariableGroup.Liveboard,
        key: '--ts-var-liveboard-group-description-font-size',
        type: CssVariableType.Size,
        name: 'Description Font Size',
        subGroup: 'Group',
      },
      {
        group: VariableGroup.Liveboard,
        key: '--ts-var-liveboard-group-description-font-weight',
        type: CssVariableType.Size,
        name: 'Description Font Weight',
        subGroup: 'Group',
      },
      {
        group: VariableGroup.Liveboard,
        key: '--ts-var-liveboard-group-background',
        type: CssVariableType.Color,
        name: 'Background Color',
        subGroup: 'Group',
      },
      {
        group: VariableGroup.Liveboard,
        key: '--ts-var-liveboard-group-border-color',
        type: CssVariableType.Color,
        name: 'Border Color',
        subGroup: 'Group',
      },
      {
        group: VariableGroup.Liveboard,
        key: '--ts-var-liveboard-group-title-font-color',
        type: CssVariableType.Color,
        name: 'Title Font Color',
        subGroup: 'Group',
      },
      {
        group: VariableGroup.Liveboard,
        key: '--ts-var-liveboard-group-description-font-color',
        type: CssVariableType.Color,
        name: 'Description Font Color',
        subGroup: 'Group',
      },

      // Group Tile
      {
        group: VariableGroup.Liveboard,
        key: '--ts-var-liveboard-group-tile-background',
        type: CssVariableType.Color,
        name: 'Background Color',
        subGroup: 'Group Tile',
      },
      {
        group: VariableGroup.Liveboard,
        key: '--ts-var-liveboard-group-tile-title-font-size',
        type: CssVariableType.Size,
        name: 'Title Font Size',
        subGroup: 'Group Tile',
      },
      {
        group: VariableGroup.Liveboard,
        key: '--ts-var-liveboard-group-tile-title-font-weight',
        type: CssVariableType.Size,
        name: 'Title Font Weight',
        subGroup: 'Group Tile',
      },
      {
        group: VariableGroup.Liveboard,
        key: '--ts-var-liveboard-group-tile-border',
        type: CssVariableType.Size,
        name: 'Border Color',
        subGroup: 'Group Tile',
      },
      {
        group: VariableGroup.Liveboard,
        key: '--ts-var-liveboard-group-tile-padding',
        type: CssVariableType.Size,
        name: 'Padding',
        subGroup: 'Group Tile',
      },
      {
        group: VariableGroup.Liveboard,
        key: '--ts-var-liveboard-group-tile-title-font-color',
        type: CssVariableType.Color,
        name: 'Title Font Color',
        subGroup: 'Group Tile',
      },

      {
        group: VariableGroup.Liveboard,
        key: '--ts-var-liveboard-answer-viz-padding',
        type: CssVariableType.Size,
        name: 'Answer Viz Padding',
        subGroup: 'Answer Viz',
      },

      {
        group: VariableGroup.Liveboard,
        key: '--ts-var-liveboard-notetitle-heading-font-color',
        type: CssVariableType.Color,
        name: 'Heading Font Color',
        subGroup: 'Note Title',
      },
      {
        group: VariableGroup.Liveboard,
        key: '--ts-var-liveboard-notetitle-body-font-color',
        type: CssVariableType.Color,
        name: 'Body Font Color',
        subGroup: 'Note Title',
      },

      {
        group: VariableGroup.Liveboard,
        key: '--ts-var-side-panel-width',
        type: CssVariableType.Size,
        name: 'Panel Width',
        subGroup: 'Side Panel',
      },
      {
        group: VariableGroup.Liveboard,
        key: '--ts-var-liveboard-edit-bar-background',
        type: CssVariableType.Color,
        name: 'Background Color',
        subGroup: 'Edit Bar',
      },
      {
        group: VariableGroup.Liveboard,
        key: '--ts-var-liveboard-dual-column-breakpoint',
        type: CssVariableType.Size,
        name: 'Dual Column Breakpoint',
        subGroup: 'Column',
      },
      {
        group: VariableGroup.Liveboard,
        key: '--ts-var-liveboard-single-column-breakpoint',
        type: CssVariableType.Size,
        name: 'Single Column Breakpoint',
        subGroup: 'Column',
      },
      {
        group: VariableGroup.Liveboard,
        key: '--ts-var-liveboard-cross-filter-layout-background',
        type: CssVariableType.Color,
        name: 'Layout Background Color',
        subGroup: 'Cross Filter Layout',
      },
    ]) ||
      []),

    // Tab
    {
      group: VariableGroup.Liveboard,
      key: '--ts-var-liveboard-tab-hover-color',
      type: CssVariableType.Color,
      name: 'Tab Hover Color',
      subGroup: 'Tab',
    },
    {
      group: VariableGroup.Liveboard,
      key: '--ts-var-liveboard-tab-active-border-color',
      type: CssVariableType.Color,
      name: 'Tab Active Border Color',
      subGroup: 'Tab',
    },

    // Liveboard Chip
    {
      group: VariableGroup.Liveboard,
      key: '--ts-var-liveboard-chip-background',
      type: CssVariableType.Color,
      name: 'Background Color',
      subGroup: 'Liveboard Chip',
    },
    {
      group: VariableGroup.Liveboard,
      key: '--ts-var-liveboard-chip--hover-background',
      type: CssVariableType.Color,
      name: 'Hover Background Color',
      subGroup: 'Liveboard Chip',
    },
    {
      group: VariableGroup.Liveboard,
      key: '--ts-var-liveboard-chip--active-background',
      type: CssVariableType.Color,
      name: 'Active Background Color',
      subGroup: 'Liveboard Chip',
    },
    {
      group: VariableGroup.Liveboard,
      key: '--ts-var-liveboard-chip-color',
      type: CssVariableType.Color,
      name: 'Text Color',
      subGroup: 'Liveboard Chip',
    },

    {
      group: VariableGroup.Liveboard,
      key: '--ts-var-liveboard-chip--hover-color',
      type: CssVariableType.Color,
      name: 'Hover Text Color',
      subGroup: 'Liveboard Chip',
    },

    {
      group: VariableGroup.Liveboard,
      key: '--ts-var-liveboard-chip--active-color',
      type: CssVariableType.Color,
      name: 'Active Text Color',
      subGroup: 'Liveboard Chip',
    },

    // Header Action Button
    {
      group: VariableGroup.Liveboard,
      key: '--ts-var-liveboard-header-action-button-background',
      type: CssVariableType.Color,
      name: 'Background Color',
      subGroup: 'Header Action Button',
    },
    {
      group: VariableGroup.Liveboard,
      key: '--ts-var-liveboard-header-action-button-font-color',
      type: CssVariableType.Color,
      name: 'Text Color',
      subGroup: 'Header Action Button',
    },
    {
      group: VariableGroup.Liveboard,
      key: '--ts-var-liveboard-header-action-button-hover-color',
      type: CssVariableType.Color,
      name: 'Hover Text Color',
      subGroup: 'Header Action Button',
    },
    {
      group: VariableGroup.Liveboard,
      key: '--ts-var-liveboard-header-action-button-active-color',
      type: CssVariableType.Color,
      name: 'Active Text Color',
      subGroup: 'Header Action Button',
    },

    // Header Badge
    {
      group: VariableGroup.Liveboard,
      key: '--ts-var-liveboard-header-badge-background',
      type: CssVariableType.Color,
      name: 'Background Color',
      subGroup: 'Header Badge',
    },
    {
      group: VariableGroup.Liveboard,
      key: '--ts-var-liveboard-header-badge-modified-background',
      type: CssVariableType.Color,
      name: 'Modified Background Color',
      subGroup: 'Header Badge',
    },
    {
      group: VariableGroup.Liveboard,
      key: '--ts-var-liveboard-header-badge-font-color',
      type: CssVariableType.Color,
      name: 'Text Color',
      subGroup: 'Header Badge',
    },
    {
      group: VariableGroup.Liveboard,
      key: '--ts-var-liveboard-header-badge-hover-color',
      type: CssVariableType.Color,
      name: 'Hover Text Color',
      subGroup: 'Header Badge',
    },
    {
      group: VariableGroup.Liveboard,
      key: '--ts-var-liveboard-header-badge-active-color',
      type: CssVariableType.Color,
      name: 'Active Text Color',
      subGroup: 'Header Badge',
    },
    {
      group: VariableGroup.Liveboard,
      key: '--ts-var-liveboard-header-badge-modified-font-color',
      type: CssVariableType.Size,
      name: 'Modified Font Color',
      subGroup: 'Header Badge',
    },
  ];
};

const spotIQVariablesMetaData: any[] = [
  {
    group: VariableGroup.SpotIQ,
    key: '--ts-var-change-analysis-insights-background',
    type: CssVariableType.Color,
    name: 'Insights Background Color',
    subGroup: 'Insights',
  },
  {
    group: VariableGroup.SpotIQ,
    key: '--ts-var-spotiq-analyze-forecasting-card-background',
    type: CssVariableType.Color,
    name: 'Card Background Color',
    subGroup: 'Forecasting Card',
  },
  {
    group: VariableGroup.SpotIQ,
    key: '--ts-var-spotiq-analyze-outlier-card-background',
    type: CssVariableType.Color,
    name: 'Card Background Color',
    subGroup: 'Outlier Card',
  },
  {
    group: VariableGroup.SpotIQ,
    key: '--ts-var-spotiq-analyze-trend-card-background',
    type: CssVariableType.Color,
    name: 'Card Background Color',
    subGroup: 'Trend Card',
  },
  {
    group: VariableGroup.SpotIQ,
    key: '--ts-var-spotiq-analyze-crosscorrelation-card-background',
    type: CssVariableType.Color,
    name: 'Card Background Color',
    subGroup: 'Cross Correlation Card',
  },
  {
    group: VariableGroup.SpotIQ,
    key: '--ts-var-cca-modal-summary-header-background',
    type: CssVariableType.Color,
    name: 'Summary Header Background',
    subGroup: 'Summary Header',
  },
];

/**
 * Gets basic variables metadata without feature flag dependencies.
 * This function is synchronous and returns only variables that don't require
 * authentication or feature flag data, enabling immediate display.
 *
 * @returns Array of basic variable metadata objects
 */
export const getBasicVariablesMetaData = (): any[] => {
  return [
    ...buttonVariablesMetaData,
    ...applicationVariablesMetaData,
    ...searchVariablesMetaData,
    ...objectListVariablesMetaData,
    ...modularHomepageVariablesMetaData,
    ...checkboxVariablesMetaData,
    ...menuVariablesMetaData,
    ...chartsVariablesMetaData,
    ...navbarVariablesMetaData,
    ...nlsVariablesMetaData,
    ...chipVariablesMetaData,
    ...dialogVariablesMetaData,
  ];
};

/**
 * Gets all variables metadata including feature flag-dependent variables.
 * This function is async and waits for authentication and feature flag data.
 * Used to provide the complete set of variables after initial loading.
 *
 * @returns Promise that resolves to array of all variable metadata objects
 */
export const variablesMetaData = async (): Promise<any[]> => {
  const infoObject = (await getInfoObject()) as any;
  const configInfo = infoObject?.info?.configInfo;
  const spotterEnabled =
    configInfo?.isSpotterExperienceEnabled && configInfo?.aiAnswerGenerationEnabled;
  const spotIQEnabled =
    configInfo?.a3Config?.a3LiveDataAnalysisEnabled &&
    infoObject?.info?.privileges?.includes('A3ANALYSIS');

  const result = [
    ...buttonVariablesMetaData,
    ...(spotterEnabled ? spotterVariablesMetaData : []),
    ...applicationVariablesMetaData,
    ...searchVariablesMetaData,
    ...objectListVariablesMetaData,
    ...modularHomepageVariablesMetaData,
    ...checkboxVariablesMetaData,
    ...menuVariablesMetaData,
    ...chartsVariablesMetaData,
    ...navbarVariablesMetaData,
    ...nlsVariablesMetaData,
    ...chipVariablesMetaData,
    ...dialogVariablesMetaData,
    ...(await getLiveboardVariablesMetaData()),
    ...(spotIQEnabled ? spotIQVariablesMetaData : []),
  ];

  return result;
};
